import React, {useContext} from "react"
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import MetricView from "./MetricView";
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import {NO, YES} from "../util/Constants";

const AssociatePerformanceMetrics = () => {
    const {states} = useContext(AssociateFilterContext)
    const {viewModel} = useContext(AssociatePerformanceContext);

    const filteredAssociates = viewModel.associatePerformance
        .filter(associate => states.length === 0 || states.includes(associate.active));
    const activeAssociateCount = filteredAssociates.filter(associate => associate.active === YES).length;
    const inActiveAssociateCount = filteredAssociates.filter(associate => associate.active === NO).length;

    return (
        <Row spacingInset="none none medium none">
            <Box type="outline" spacingInset="medium">
                <MetricView data={{
                    headerId: "associate.totalAssociates",
                    defaultHeader: "Total associates",
                    metricValue: filteredAssociates.length
                }}/>
            </Box>

            <Box type="outline" spacingInset="medium">
                <Row>
                    <MetricView data={{
                        headerId: "associate.associatesWithPicklist",
                        defaultHeader: "Associates with picklist assigned",
                        metricValue: activeAssociateCount
                    }}/>
                    <MetricView data={{
                        headerId: "associate.associatesWithoutPicklist",
                        defaultHeader: "Associates with no picklist assigned",
                        metricValue: inActiveAssociateCount
                    }}/>
                </Row>
            </Box>
        </Row>
    )
}

export default AssociatePerformanceMetrics


// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociatePerformanceMetrics.js